import {request} from "./requests";
import {Entity, Profile} from "./converter";
import util from 'util';

/**
 * ------------------------------------------------------------
 * 注意，import 侧如果要调用这个方法，必须在 getProfile 上 bind this，否则调用方的 this.$store 无法传递进来。
 * 示例代码
 * > import {getProfile} from '../../../data/profile';
 * > getProfile.bind(this)(code).then(...)
 * ------------------------------------------------------------
 *
 * 使用逻辑： first find it from cache, if not found, then get it remote.
 *
 * @param code, the profile code
 * @return Promise
 */
export async function getProfile(code) {
    // first, get it from cache
    let p = this.$store.getters.getProfile(code);
    // if not fetched from cache, then retrieve it remotely
    if(util.isNullOrUndefined(p)){
        console.log(`get profile via code ${code} from cache failed, try to fetch it remotely`);
        try{
            // second, if not exists in cache, fetch remote
            p = await request({
                url: `/p/${code}`,
                method: 'get',
                retriable: true
            });
            console.log(`raw profile retrieved via ${code} from remote get ${JSON.stringify(p)}`);
            p = Profile.convertProfile(p);
            this.$store.commit('setProfile', p); // cache the converted profile
            return p;
        }catch(error){
            throw error;
        }
    }else{
        console.log(`get profile via code ${code} from cache is ${JSON.stringify(p)}`);
        return p;
    }
}

/**
 * ------------------------------------------------------------
 * 注意，import 侧如果要调用这个方法，必须在 getProfile 上 bind this，否则调用方的 this.$store 无法传递进来。
 * 示例代码
 * > import {getProfile} from '../../../data/profile';
 * > getProfile.bind(this)(code).then(...)
 * ------------------------------------------------------------
 *
 * 注意，并不会到 cache 中去查找，直接发起远程获取。调用方需要排除这些已经被缓存的 profile codes。远程获取成功以后，会 cache 到本地。
 *
 * @param codes
 * @return {Promise<*[]>}
 */
export async function getProfiles(codes) {
    console.log('getProfiles, codes:', codes);
    let profiles = await request({
        url: `/p/list`,
        method: 'post',
        data: JSON.stringify(codes),
        retriable: true
        // 必须设置 content-type 为 application/json，否则服务器端不会直接解析为 Array，已经添加到 requests.js 中
        // headers: {'Content-Type': 'application/json'}
    });
    profiles = Profile.convertProfiles(profiles);
    console.log('getProfiles, profiles:', profiles);
    for(let p of profiles)
        this.$store.commit('setProfile', p); // cache the converted profile
    return profiles;
}


/**
 *
 * @param code, the profile code
 * @param mode, [1, 2, 3, 4] 分别表示"综合热点"，"热门图集"，"热门视频"和"最近更新"
 * @param pageNum
 * @return Promise
 */
export async function getPage(code, mode, pageNum) {
    let data = await request({
        url: `/p/pg/${code}/${mode}?page=${pageNum}`, // 这里的 pg 是 page 的意思
        method: 'get',
        retriable: true
    });
    return Entity.convertEntities(data);
}

/**
 *
 * @param code, profile code
 * @param uploadTs, 页面上缓存的最新 uploadTs
 * @param pageNum
 * @return Promise
 */
export async function getNewest(code, uploadTs, pageNum){
    let data = await request({
        url: `/p/pg/${code}/newest?page=${pageNum}&ts=${uploadTs}`,
        method: 'get',
        retriable: true
    });
    return Entity.convertEntities(data);
}

/**
 *
 * @param profileCode
 * @param shortcode, the shortcode itself should be excluded from the recommendation
 * @return {Promise<Array>}
 */
export async function getSample(profileCode, shortcode){
    let entities = await request({
        url: `/p/sample/${profileCode}?excludes=${shortcode}`,
        method: 'get',
        retriable: true
    });
    return Entity.convertEntities(entities);
}








// WEBPACK FOOTER //
// ./src/data/profile.js